import FanTable from './FanTable';

export default FanTable;
